const apiConfig = {
    baseUrl: 'https://api.themoviedb.org/3/',
    apiKey: 'a2fb463822e6f40fa051ec31fa2c9538',
    originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
    w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500/${imgPath}`
}

export default apiConfig;
//sfsafsaf